export default __webpack_public_path__ + "static/2-a44aea851d07110d5d2ef5a36e2bc2fd.png";